import { Link } from 'react-router-dom';
import { BedMapsIcon, Logo } from './parts.jsx';
import { footerColumns, footerPhoneColumns, legalLinks } from './navigation.js';

export default function SiteFooter() {
  return <footer className="mk-footer">
    <div className="mk-container">
      <div className="mk-footer-top">
        <Link className="mk-footer-logo" to="/" aria-label="Resident Service 360 home"><Logo/></Link>
        <p className="mk-footer-promise">Book a repair from checked local tradespeople.</p>
        <p className="mk-footer-bedmaps"><BedMapsIcon size={24}/>Works with BedMaps</p>
        <nav className="mk-footer-links is-wide" aria-label="Footer">
          {footerColumns.map((column) => <div className="mk-footer-column" key={column.heading}>
            <p className="mk-footer-heading">{column.heading}</p>
            <ul>{column.links.map((link) => <li key={link.to}><Link to={link.to}>{link.label}</Link></li>)}</ul>
          </div>)}
        </nav>
        <nav className="mk-footer-links is-phone" aria-label="Footer">
          {footerPhoneColumns.map((links, index) => <ul className="mk-footer-column" key={index}>
            {links.map((link) => <li key={link.to}><Link to={link.to}>{link.label}</Link></li>)}
          </ul>)}
        </nav>
      </div>
      <div className="mk-footer-bottom">
        <p>Resident Service 360 · An Aston Metrics product</p>
        <ul className="mk-footer-legal">{legalLinks.map((link) => <li key={link.to}><Link to={link.to}>{link.label}</Link></li>)}</ul>
      </div>
    </div>
  </footer>;
}
